var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.5H3.27002L8.58002 2.2C8.97002 1.81 8.97002 1.18 8.58002 0.789998C8.19002 0.399998 7.55998 0.399998 7.16998 0.789998L0.400024 7.54C0.160024 7.78 0.0400195 8.1 0.0200195 8.42C0.0200195 8.45 0 8.47 0 8.5C0 8.53 0.0100195 8.55 0.0200195 8.58C0.0400195 8.9 0.160024 9.22 0.400024 9.46L7.16998 16.21C7.36998 16.4 7.62 16.5 7.88 16.5C8.14001 16.5 8.39003 16.4 8.59003 16.21C8.98003 15.82 8.98003 15.19 8.59003 14.8L3.28003 9.51H19.01C19.56 9.51 20.01 9.06 20.01 8.51C20.01 7.96 19.56 7.51 19.01 7.51L19 7.5Z",
    fill: "#676A71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRet);
export default __webpack_public_path__ + "static/media/ret.73239088f4223b86390fa043994b15cf.svg";
export { ForwardRef as ReactComponent };